var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import MaterialTooltip from "@mui/material/Tooltip";
// styles
import "./tooltip.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    placement: "bottom",
    followCursor: false,
    "data-testid": "tecma-tooltip",
};
/**
 * A means of displaying a description or extra information about an element, usually on hover, but can also be on click or tap.
 */
const Tooltip = (_a) => {
    var { title, children, className } = _a, rest = __rest(_a, ["title", "children", "className"]);
    const classList = classNames("tecma-tooltip", className);
    return (_jsx(MaterialTooltip, Object.assign({ title: title }, rest, { className: classList, children: children })));
};
Tooltip.defaultProps = defaultProps;
export default React.memo(Tooltip);
